import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Timeline } from 'reactSite/MyOrders/components/Timeline'
import { ShippingAddress } from 'reactSite/MyOrders/components/ShippingAddress'
import { BuilderDisclaimer } from 'reactSite/MyOrders/modules/messages/shipment'

import { useProfile } from 'checkout/hooks/use-profile'
import { Notification } from 'checkout/components/Notification'

import * as S from './styled'
import { LockerPinMessage } from './components'

const ShipmentContent = ({
  type,
  items,
  shippingAddress,
  deliveryDate,
  steps,
  hasCarrierTracking,
  trackingUrl,
  pinCode,
  phone
}) => {
  const { profile } = useProfile()

  const Price = ({ integers, decimals }) => (
    <span>
      R$ {integers}, {decimals}
    </span>
  )

  const message = deliveryDate && deliveryDate.message

  const openChatBot = () => {
    window.ChatWidget.open()
  }

  const orderInfo = {
    type,
    steps,
    hasRegionDriveThru: profile.regionDriveThru
  }

  return (
    <S.Wrapper>
      {!!steps && <Timeline steps={steps} />}

      <BuilderDisclaimer {...orderInfo} />

      <S.LockerPinWrapper>
        <LockerPinMessage type={type} steps={steps} pinCode={pinCode} phone={phone} />
      </S.LockerPinWrapper>

      {items.map((item, index) => (
        <div key={index} className="item-box">
          <div className="item-thumb">
            <img src={item.image} width="75" height="75" />
            <div>
              <a href={item.url}>
                <span>{item.name}</span>
              </a>
              <div className="margin-top-small small shop-name">
                <span className="color-default">
                  Vendido e entregue por{' '}
                  <strong>{item.shopName || 'Leroy Merlin'}</strong>
                </span>
              </div>
            </div>
          </div>

          <div className="items-infos">
            <div className="infos-box">
              <div className="item">
                <div className="item-title">Qtde.</div>
                <span>{item.quantity}</span>
              </div>
              <div className="item">
                <div className="item-title">Valor unit.</div>
                <Price
                  decimals={item.price.unit.decimals}
                  integers={item.price.unit.integers}
                />
              </div>
              <div className="item">
                <div className="item-title">Subtotal</div>
                <Price
                  decimals={item.price.subTotal.decimals}
                  integers={item.price.subTotal.integers}
                />
              </div>
              {item.status && (
                <div className="item">
                  <div className="item-title">Status</div>
                  <span>{item.status}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}

      <ShippingAddress
        addressType={type}
        hasCarrierTracking={hasCarrierTracking}
        trackingUrl={trackingUrl}
        {...shippingAddress}
        observation={message}
      />

      <Notification>
        <Text size="kilo" noMargin>
          <Text as="strong" size="kilo" noMargin bold>
            Atenção:{' '}
          </Text>
          A Leroy utiliza o WhatsApp{' '}
          <Text as="strong" size="kilo" noMargin bold>
            apenas para se comunicar sobre pedidos e fazer vendas
          </Text>,
          porém{' '}
          <Text as="strong" size="kilo" noMargin bold>
            não envia nenhum tipo de código{' '}
          </Text>
          para confirmar ou acessar sua conta em nossos canais de venda.{' '}
          <Text as="strong" size="kilo" noMargin bold>
            Não compartilhe seus dados com ninguém
          </Text>.
          Em caso de dúvidas, utilize nossos canais digitais de atendimento:{' '}
          <S.Link href="/fale-conosco">Fale conosco</S.Link> e{' '}
          <S.CustomLink onClick={openChatBot}>LIA</S.CustomLink>.
        </Text>
      </Notification>
    </S.Wrapper>
  )
}

export default ShipmentContent
